<template>
  <v-card>
    <v-card-text class="text-center text-h4" id="about">About me</v-card-text>
    <v-card width="70%" class="mx-auto" v-if="!$vuetify.breakpoint.mobile" flat>
    <v-row justify="center" align="center">
      <v-col>
        <v-card-text>
          <v-card-text class="ml-10 text-h5">Education</v-card-text>
          <v-timeline align-top dense>
            <v-timeline-item color="orange" small v-for="(item,index) in education" :key="index">
              <v-card color="transparent" flat>
                <v-card-title>{{ item.course }}</v-card-title>
                <v-card-subtitle
                  >{{ item.university }}<br>{{ item.year }}</v-card-subtitle
                >
              </v-card>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>
      </v-col>
      <v-col>
        <v-card-text>
          <v-card-text class="ml-10 text-h5">Experience</v-card-text>
          <v-timeline align-top dense>
            <v-timeline-item color="orange" small v-for="(item,index) in experiences" :key="index">
              <v-card color="transparent" flat>
                <v-card-title>{{ item.office }}</v-card-title>
                <v-card-subtitle
                  >{{ item.length }}<br>{{ item.work }}</v-card-subtitle
                >
              </v-card>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>
      </v-col>
    </v-row>
</v-card>
<v-card width="100%" class="mx-auto" v-if="$vuetify.breakpoint.mobile" flat>
    
        <v-card-text>
          <v-card-text class="ml-10 text-h5">Education</v-card-text>
          <v-timeline align-top dense>
            <v-timeline-item color="orange" small v-for="(item,index) in education" :key="index">
              <v-card color="transparent" flat>
                <v-card-title>{{ item.course }}</v-card-title>
                <v-card-subtitle
                  >{{ item.university }}<br>{{ item.year }}</v-card-subtitle
                >
              </v-card>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>
 
     
        <v-card-text>
          <v-card-text class="ml-10 text-h5">Experience</v-card-text>
          <v-timeline align-top dense>
            <v-timeline-item color="orange" small v-for="(item,index) in experiences" :key="index">
              <v-card color="transparent" flat>
                <v-card-title>{{ item.office }}</v-card-title>
                <v-card-subtitle
                  >{{ item.length }}<br>{{ item.work }}</v-card-subtitle
                >
              </v-card>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>
   
</v-card>
  </v-card>
</template>

<script>
export default {
    data(){return{
        education:[
            {
                course:'Bachelor in Computer Science',
                year:'2022',
                university:'Institute of Finance Management'
            },
            {
                course:'Diploma in Computer Science',
                year:'2019',
                university:'Institute of Finance Management'
            }
        ],
        experiences:[
            {
                office:'SoftNet',
                length:'2 month',
                work:'Work in the Networking team as an intern. Participated in a major project that SoftNet received from Tanzania Revenue Authority (TRA)'
            },
            {
                office:'LockWood',
                length:'1 Month',
                work:'Worked on a payment gateway using web technologies. Such as Laravel participated in the development of their REST API'
            },
            {
                office:'FreeLance',
                length:'From 2019 - To date',
            },
            {
                office:'Fabonic',
                length:'2022 - To date',
                work:'Involved in various project ranging from mobile development, Web development, Api intergration and development and customer trainig and support for the companies clients'

            },
        ]
    }}
};
</script>

<style></style>
